/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
// import axios from "axios";
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  FormGroup,
  Spinner,
  Table,
  Modal,
  PaginationLink,
  PaginationItem,
  Pagination,
  UncontrolledTooltip,
} from "reactstrap";

import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

// actions
import {
  getAvailabilities,
  deleteAvailability,
  resetError,
  resetAvailabilities,
} from "../../store/availability/actions";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";
import { renderPagination } from "../../Libs/CrudUtils/crudUtils";

//Redux

const QuickReplies = ({ t }) => {
  const dispatch = useDispatch();

  const qtdDefault = 7;
  const {
    dataAvailability,
    dataAvailabilityDelete,
    loadingAvailability,
    loadingAvailabilityDelete,
    errorAvailabilityCRUD,
    successAvailability,
  } = useSelector((state) => state.Availability);

  const [page, setPage] = useState(1);
  const [availId, setAvailId] = useState("");
  const [availName, setAvailName] = useState("");
  const [modal, setModal] = useState(false);
  const [nameFilter, setNameFilter] = useState("");
  const [notFound, setNotFound] = useState(false);

  const handleFilter = (name) => {
    setNameFilter(name);
    setPage(1);
    dispatch(getAvailabilities(1, qtdDefault, name));
  };

  const handleDelete = () => {
    dispatch(deleteAvailability(availId));
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const setAvailIdName = (avail) => {
    setAvailId(avail.id);
    setAvailName(avail.name);
  };

  const handlePage = (value) => {
    setPage(value);
    dispatch(getAvailabilities(value, qtdDefault, nameFilter));
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      handlePage(page - 1);
    }
  };

  const handleNextPage = () => {
    if (dataAvailability && dataAvailability.paging) {
      if (page < dataAvailability.paging.length) {
        handlePage(page + 1);
      }
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successAvailability && dispatch(resetAvailabilities()) && handleFilter(),
  };
  useEffect(() => {
    if (dataAvailabilityDelete && dataAvailabilityDelete.message) {
      showToast("success", t(dataAvailabilityDelete.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successAvailability]);

  useEffect(() => {
    if (errorAvailabilityCRUD && Array.isArray(errorAvailabilityCRUD)) {
      errorAvailabilityCRUD.map(
        //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
        (error) =>
          error.value === "Availabilities not found" &&
          showToast("error", t(error.value))
      );
      dispatch(resetError());
    } else {
      if (errorAvailabilityCRUD) {
        showToast("error", t(errorAvailabilityCRUD));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorAvailabilityCRUD]);

  useEffect(() => {
    if (dataAvailability !== null) {
      setNotFound(false);
    } else {
      setNotFound(true);
    }
  }, [dataAvailability]);

  useEffect(() => {
    handleFilter();
  }, []);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            mainPath="/dashboard"
            path="/availabilities"
            title={t("Dashboard")}
            breadcrumbItem={t("Availabilities")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody className="card-height">
                  <AvForm
                    onValidSubmit={(event, values) => {
                      handleFilter(values.name);
                    }}
                  >
                    <Row>
                      <Col xs="12" md="4" lg="2" className="mb-3">
                        <FormGroup>
                          <AvField
                            label={t("Name")}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("Name") + "..."}
                            validate={{
                              pattern: {
                                value: "/^[A-Za-z0-9 áàâãéèêíïóôõöúç]*$/i", // only letters, numbers and space
                                errorMessage: t(
                                  "Name must be composed only with letter and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Min 3 characters"),
                              },
                              maxLength: {
                                value: 60,
                                errorMessage: t("Max 60 characters"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 filter-create-btn"
                      >
                        <Button
                          type="submit"
                          color="primary"
                          className="waves-effect waves-light w-100 mb-3 mr-3"
                        >
                          <i className="mdi mdi-feature-search-outline mr-1"></i>
                          {t("Search")}
                        </Button>
                      </Col>
                      <Col
                        xs="12"
                        md="4"
                        lg="auto"
                        className="mt-auto mb-3 ml-auto filter-create-btn"
                      >
                        <div className="text-sm-right mb-3" id="quick-replies">
                          <Link to="/availability">
                            <Button
                              type="button"
                              color="success"
                              className={"waves-effect waves-light w-100 mr-2 "}
                            >
                              <i className="mdi mdi-plus mr-1"></i>
                              {t("Add Availabilities")}
                            </Button>
                          </Link>
                        </div>
                      </Col>
                    </Row>
                  </AvForm>
                  <div className="table-responsive">
                    <PerfectScrollbar>
                      <Table className="table table-centered table-nowrap">
                        <thead className="thead-light">
                          <tr>
                            <th>{t("#")}</th>
                            <th>{t("Name")}</th>
                            <th>{t("Description")}</th>
                            <th>{t("Type")}</th>
                            <th style={{ textAlign: "right" }}>
                              {t("Action")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {loadingAvailability ? (
                            <tr>
                              <td colSpan="20" align="center">
                                <Spinner
                                  size="sm"
                                  animation="border"
                                  style={{
                                    marginTop: "40px",
                                    height: "50px",
                                    width: "50px",
                                  }}
                                />
                              </td>
                            </tr>
                          ) : notFound ? (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("Click search to show the records")}
                              </td>
                            </tr>
                          ) : dataAvailability &&
                            dataAvailability.responseAvailabilities &&
                            dataAvailability.responseAvailabilities.length >
                              0 ? (
                            dataAvailability.responseAvailabilities.map(
                              (avail, key) => (
                                <tr key={key}>
                                  <td className="pl-4">{key + 1}</td>
                                  <td className="column-text-overflow-10">
                                    {t(avail.name)}
                                  </td>
                                  <td className="column-text-overflow-20">
                                    {avail.description}
                                  </td>
                                  <td className="column-text-overflow-10">
                                    {t(avail.type)}
                                  </td>
                                  {avail.name !== "Online" &&
                                  avail.name !== "Volto logo" &&
                                  avail.name !== "Ausente" ? (
                                    <td className="pl-0" align="right">
                                      <Link
                                        to={`/availability/${avail.id}`}
                                        className="text-primary text-center"
                                        id="edit"
                                      >
                                        <i
                                          className="mdi mdi-pencil font-size-18 px-2"
                                          id={`edittooltip${avail.id}`}
                                        >
                                          <UncontrolledTooltip
                                            placement="auto"
                                            target={`edittooltip${avail.id}`}
                                          >
                                            {t("Edit")}
                                          </UncontrolledTooltip>
                                        </i>
                                      </Link>
                                      {/* TODO: add custom styles to css file */}
                                      <span style={{ cursor: "pointer" }}>
                                        <i
                                          className="mdi mdi-window-close text-danger font-size-18 px-2"
                                          id={`deletetooltip${avail.id}`}
                                          onClick={() => {
                                            toggleModal();
                                            setAvailIdName(avail);
                                          }}
                                        >
                                          {" "}
                                          <UncontrolledTooltip
                                            placement="auto"
                                            target={`deletetooltip${avail.id}`}
                                          >
                                            {t("Delete")}
                                          </UncontrolledTooltip>
                                        </i>
                                      </span>
                                    </td>
                                  ) : (
                                    <td className="pl-0" align="right">
                                      <span className="isDisabled">
                                        {" "}
                                        <Link
                                          to="#"
                                          className="text-primary text-center"
                                          style={{
                                            pointerEvents: "none",
                                            cursor: "no-drop",
                                          }}
                                        >
                                          <i className="mdi mdi-pencil font-size-18 px-2"></i>
                                        </Link>
                                        <i className="mdi mdi-window-close text-danger font-size-18 px-2"></i>
                                      </span>
                                    </td>
                                  )}
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="20" align="center">
                                {t("No matching records found")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </Table>
                      <Modal isOpen={modal || loadingAvailabilityDelete}>
                        <div className="modal-body font-size-18 text-center">
                          {t("Do you want delete")}
                          <strong> {availName}</strong>?
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            onClick={toggleModal}
                            className="btn btn-danger waves-effect"
                            data-dismiss="modal"
                            style={{ backgroundColor: "#f14646" }}
                          >
                            {t("No")}
                          </button>

                          {loadingAvailabilityDelete ? (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light"
                            >
                              <Spinner size="sm" animation="border" />
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-secondary waves-effect waves-light btn-dark"
                              onClick={() => {
                                toggleModal();
                                if (availId) handleDelete();
                              }}
                            >
                              {t("Yes")}
                            </button>
                          )}
                        </div>
                      </Modal>
                    </PerfectScrollbar>
                  </div>
                  {renderPagination(
                    page,
                    dataAvailability?.paging,
                    handlePreviousPage,
                    handlePage,
                    handleNextPage
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(QuickReplies);
